import styled from "styled-components";
import React from "react";
import {scaledValue} from "../../../performance/CompactPerformanceValue";

const ExpandLink = styled.div`
    color: #3b7433;
    text-decoration: underline;
    cursor: pointer;
`;

const InvestmentAmount = styled.span`
    font-style: italic;
    font-weight: bold;
`;

const PortfolioAction = ({action, portfolio}) => {
    if (action === "Close" || action === "Autoclose") {
        return <span className="t-portfolio-action">{portfolio.name}</span>
    } else {
        const actionText = `(${scaledValue(portfolio.totalInvestment)} ${portfolio.investmentCurrency})`;
        return <span className="t-portfolio-action">
            {portfolio.name} <InvestmentAmount>{actionText}</InvestmentAmount>
        </span>
    }
};

export const PortfolioActions = ({activityId, action, portfolios, ideaActions, expanded}) => {
    const controls = {
        expandPortfolios(event) {
            event.preventDefault();
            ideaActions.expandHistoryActivityPortfolios(activityId);
        },
        collapsePortfolios(event) {
            event.preventDefault();
            ideaActions.collapseHistoryActivityPortfolios(activityId);
        }
    };
    if (portfolios.length > 3) {
        if (!expanded) {
            const firstPortfolios = portfolios.slice(0, 3);
            return (
                <React.Fragment>
                    {firstPortfolios.map(portfolio =>
                        <PortfolioAction key={portfolio.id} action={action} portfolio={portfolio}/>
                    )}
                    <ExpandLink className="t-expand-link"
                                onClick={controls.expandPortfolios}>{portfolios.length - 3} more</ExpandLink>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    {portfolios.map(portfolio => <PortfolioAction key={portfolio.id}
                                                                  action={action}
                                                                  portfolio={portfolio}/>)}
                    <ExpandLink className="t-expand-link" onClick={controls.collapsePortfolios}>Less</ExpandLink>
                </React.Fragment>
            );
        }
    } else {
        return (
            portfolios.map(portfolio => <PortfolioAction key={portfolio.id} action={action} portfolio={portfolio}/>)
        );
    }
};